import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResult } from '../../shared/types/api-result.types';
import { BrandsService } from '../brands/brands.service';
import { BaseService } from '../services/base.service';
import { ThemeService } from '../theme/theme.service';
import { GetConfigurationResponse } from './configuration.types';

@Injectable({
    providedIn: 'root',
})
export class AppConfigService extends BaseService {
    private config: GetConfigurationResponse;

    constructor(
        private httpClient: HttpClient,
        private themeService: ThemeService,
        private brandService: BrandsService
    ) {
        super();
    }

    async loadConfig(): Promise<GetConfigurationResponse> {
        try {
            const response = await firstValueFrom(
                this.httpClient.get<ApiResult<GetConfigurationResponse>>(`${environment.apiUrl}/configuration`)
            );

            if (!response.isSuccess) {
                return Promise.reject(
                    Error('API configuration Response code returned network-error:' + response.error?.title)
                );
            }

            this.config = response.result;
            this.themeService.loadTheme(this.config.theme);
            this.brandService.initInfo(response.result.brand);
            return this.config;
        } catch (error) {
            console.error('Failed to load configuration');
            //Load the theme by passing an undefined configuration, to set default variable values.
            this.themeService.loadTheme(undefined);
            throw error;
        }
    }

    get systemConfig() {
        return this.config.system;
    }
}
